export const messages = {
  buttonsTitle: {
    id: "auth-screen.kidmin.buttons-title",
    defaultMessage:
      "A Bible Engagement Project account is required to access your free resources",
  },
  buttonsCreate: {
    id: "auth-screen.kidmin.buttons-create",
    defaultMessage: "Create an account",
  },
  buttonsDescription: {
    id: "auth-screen.kidmin.buttons-description",
    defaultMessage:
      "Your BEP Google and Apple Social Sign-in will not work on KidminRoadmap at this time. Create a new account using a traditional email/password.",
  },
};
